import { useQuery } from 'react-query'
import Axios from 'axios'

/**
 * Fetch analytics dashboard data.
 * @param {string} period The period to fetch ('24h', '7d')
 */
export function useAnalytics(period) {
	return useQuery(
		['analytics', period],
		async () => {
			const res = await Axios.get('/api/analytics-v2', {
				params: { period },
			})
			return res.data
		},
		{ staleTime: 5 * 60 * 1000 }
	)
}
